import React, { Component } from 'react';

class Responsibility extends Component {

  constructor(props) {
    super(props);

    this.props = props;
  }

  render() {
    const { content } = this.props;

    return (
      <section className="ga-section ga-section--responsibility">

        <div className="ga-section__wrap ga-section__wrap--center">

          <div className="ga-section__body">

            <h2 className="ga-section__title" dangerouslySetInnerHTML={{ __html: content.title.rendered }} />

            <div className="ga-section__content" dangerouslySetInnerHTML={{ __html: content.content.rendered }} />

          </div>

        </div>

      </section>
    );
  }
};

export default Responsibility;
